(() => {
  function init(home) {
    if (home.dataset.gnInitialized) return;
    home.dataset.gnInitialized = 'true';
    const run = home.querySelector('.film-run');
    const stage = home.querySelector('.film-stage');
    const canvas = home.querySelector('#film-canvas');
    const ambient = home.querySelector('#film-ambient');
    const frameWidth = canvas.width, frameHeight = canvas.height;
    const ctx = canvas?.getContext('2d', { alpha: false });
    const ambientCtx = ambient?.getContext('2d', { alpha: false });
    const play = home.querySelector('#film-play');
    const copy = home.querySelector('.film-copy');
    const controller = new AbortController();
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let sources = [];
    try { sources = JSON.parse(home.querySelector('[data-gn-frame-sources]').textContent); } catch (_) {}
    let chapters = [];
    try { chapters = JSON.parse(home.querySelector('[data-gn-chapters]').textContent); } catch (_) {}
    if (chapters.length !== 5) return;
    const cache = new Map(), loading = new Set();
    let targetFrame = 0, drawnFrame = -1, activeChapter = -1;
    let scrollRaf = 0, fadeTimer = 0, playRaf = 0, playStart = 0, playFrom = 0, previousScrollBehavior = '';

    function loadStrip(index) {
      if (!sources[index] || cache.has(index) || loading.has(index)) return;
      loading.add(index);
      const img = new Image();
      img.onload = () => { loading.delete(index); cache.set(index, img); drawFrame(targetFrame); };
      img.onerror = () => loading.delete(index);
      img.src = sources[index];
    }
    function drawFrame(frame) {
      if (!ctx || !ambientCtx) return;
      const chunk = Math.floor(frame / 10), strip = cache.get(chunk);
      if (!strip) { loadStrip(chunk); return; }
      if (frame === drawnFrame) return;
      const sx = frame % 10 * frameWidth;
      ctx.drawImage(strip, sx, 0, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);
      ambientCtx.drawImage(strip, sx, 0, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);
      drawnFrame = frame;
      stage.classList.add('ready');
      for (const key of cache.keys()) if (Math.abs(key - chunk) > 1) cache.delete(key);
      loadStrip(chunk + 1);
      loadStrip(chunk - 1);
    }
    function updateChapter(frame) {
      let index = 0;
      for (let i = chapters.length - 1; i >= 0; i--) if (frame >= chapters[i].start) { index = i; break; }
      if (index === activeChapter) return;
      activeChapter = index;
      clearTimeout(fadeTimer);
      copy.classList.add('changing');
      fadeTimer = setTimeout(() => {
        const chapter = chapters[index];
        home.querySelector('#film-chapter').textContent = chapter.eyebrow;
        const title = home.querySelector('#film-title');
        const accent = document.createElement('em');
        accent.textContent = chapter.titleAccent;
        title.replaceChildren(document.createTextNode(chapter.titleFirst), document.createElement('br'), accent);
        home.querySelector('#film-line').textContent = chapter.line;
        home.querySelector('#chapter-count').textContent = `${String(index + 1).padStart(2, '0')} / 05`;
        copy.classList.remove('changing');
      }, index === 0 ? 0 : 125);
    }
    function filmPosition(frame) {
      return run.getBoundingClientRect().top + scrollY + frame / 159 * Math.max(1, run.offsetHeight - innerHeight);
    }
    function updateFilm() {
      scrollRaf = 0;
      if (reduceMotion) return;
      const length = Math.max(1, run.offsetHeight - innerHeight);
      const progress = Math.max(0, Math.min(1, -run.getBoundingClientRect().top / length));
      targetFrame = Math.min(159, Math.round(159 * progress));
      drawFrame(targetFrame);
      updateChapter(targetFrame);
      home.querySelector('#progress-fill').style.height = `${progress * 100}%`;
    }
    function scheduleFilm() { if (!scrollRaf) scrollRaf = requestAnimationFrame(updateFilm); }
    function stopPlay() {
      if (!playRaf) return;
      cancelAnimationFrame(playRaf);
      playRaf = 0;
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      play.textContent = 'Play story';
      play.setAttribute('aria-label', 'Play story');
    }
    function playTick(now) {
      const frame = Math.min(159, playFrom + Math.floor((now - playStart) / 75));
      scrollTo(0, filmPosition(frame));
      if (frame >= 159) { stopPlay(); return; }
      playRaf = requestAnimationFrame(playTick);
    }
    play.addEventListener('click', () => {
      if (playRaf) { stopPlay(); return; }
      if (reduceMotion) { home.querySelector('#gn-story').scrollIntoView(); return; }
      playFrom = targetFrame >= 157 ? 0 : targetFrame;
      previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      if (playFrom === 0) scrollTo(0, filmPosition(0));
      playStart = performance.now();
      play.textContent = 'Pause story';
      play.setAttribute('aria-label', 'Pause story');
      playRaf = requestAnimationFrame(playTick);
    }, { signal: controller.signal });
    for (const type of ['wheel', 'touchstart', 'pointerdown']) addEventListener(type, event => {
      if (event.target !== play && !play.contains(event.target)) stopPlay();
    }, { passive: true, signal: controller.signal });
    addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', 'Escape'].includes(event.key)) stopPlay();
    }, { signal: controller.signal });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopPlay(); }, { signal: controller.signal });
    addEventListener('scroll', scheduleFilm, { passive: true, signal: controller.signal });
    addEventListener('resize', scheduleFilm, { signal: controller.signal });
    if (!reduceMotion) { loadStrip(0); updateFilm(); }

    const filters = [...home.querySelectorAll('.filter')];
    const cards = [...home.querySelectorAll('.product-card')];
    const feedback = home.querySelector('#filter-feedback');
    const filterNotes = {
      all: 'Nine featured formulas. Choose an area to follow your own path through the range.',
      hair: 'Hair & beauty · Explore a botanical and nutrient approach with Growtin.',
      movement: 'Movement · Explore joint comfort, bone health and local topical care.',
      pain: 'Pain · Explore PainKlen for mild, localised muscle and joint discomfort.',
      liver: 'Liver health · Explore Vit Ace’s milk thistle, grape seed and antioxidant nutrient formula.',
      botanical: 'Botanical care · Explore Libido Booster here and HerbaMix in the formula stories below.',
      daily: 'Daily wellbeing · Compare bone-health nutrition, botanical care and antioxidant support.'
    };
    filters.forEach(button => button.addEventListener('click', () => {
      filters.forEach(candidate => {
        const active = candidate === button;
        candidate.classList.toggle('active', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
      const filter = button.dataset.filter;
      cards.forEach(card => { card.hidden = filter !== 'all' && !card.dataset.categories.split(/\s+/).includes(filter); });
      feedback.textContent = filterNotes[filter] || filterNotes.all;
      if (filter === 'botanical') {
        const storyLink = document.createElement('a');
        storyLink.href = '#portfolio-preview';
        storyLink.textContent = ' View the HerbaMix story.';
        feedback.append(storyLink);
      }
    }, { signal: controller.signal }));

    const reveals = home.querySelectorAll('.reveal');
    let observer;
    if ('IntersectionObserver' in window && !reduceMotion) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
      }), { threshold: .12 });
      reveals.forEach(node => observer.observe(node));
    } else reveals.forEach(node => node.classList.add('visible'));
    home.gnCleanup = () => {
      stopPlay(); controller.abort(); observer?.disconnect(); clearTimeout(fadeTimer);
      cancelAnimationFrame(scrollRaf); cache.clear(); delete home.dataset.gnInitialized;
    };
  }

  function initAll(root = document) { root.querySelectorAll('[data-gn-home]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-gn-home]').forEach(home => home.gnCleanup?.()));
})();
